import { render, staticRenderFns } from "./AdminSalesMonitoringDetail.vue?vue&type=template&id=641932e9&scoped=true&"
import script from "./AdminSalesMonitoringDetail.vue?vue&type=script&lang=js&"
export * from "./AdminSalesMonitoringDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminSalesMonitoringDetail.vue?vue&type=style&index=0&id=641932e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641932e9",
  null
  
)

export default component.exports